import {BrowserRouter, Routes, Route} from "react-router-dom";
import "@/App.css";
import ProtectedRoute from "@/ProtectedRoute";
import SettingsPage from "@/SettingsPage";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import StaffLogin from "@/pages/StaffLogin";
import Dashboard from "@/pages/Dashboard";

export default function App() {
  return <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home/>}/>
      <Route path="/booking" element={<Booking/>}/>
      <Route path="/staff" element={<StaffLogin/>}/>
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard/></ProtectedRoute>}/>
      <Route path="/dashboard/settings" element={<ProtectedRoute><SettingsPage/></ProtectedRoute>}/>
    </Routes>
  </BrowserRouter>;
}
